
import { Component, Vue, Prop } from "nuxt-property-decorator";

@Component
export default class TheCategoryTipology extends Vue {
  @Prop() item!: any;
}
